import React, { createContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Provider } from "./layoutContext";
import Sidebar from "./Sidebar";
import Header from "./Header";

export const AdminContext = createContext({});

const MainLayout = () => {
  const [isAsideOpen, setIsAsideOpen] = useState(true);
  const [windowScreenWidth, setwindowScreenWidth] = useState(window.innerWidth);

  const getAccessToken = sessionStorage.getItem("accessToken");

  useEffect(() => {
    function handleResize() {
      setwindowScreenWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    windowScreenWidth < 767 && setIsAsideOpen(false);
    return () => window.removeEventListener("resize", handleResize);
  }, [windowScreenWidth]);

  return (
    <div className={`bg-lightyellow`}>
      {getAccessToken ? (
        <AdminContext.Provider>
          <Provider value={{ isAsideOpen, setIsAsideOpen }}>
            <div
              className={`h-screen flex flex-col min-w-0 flex-1 overflow-y-hidden overflow-x-hidden`}
            >
              <Header />
              <div className="flex">
                <Sidebar />
                <div className="h-[calc(100vh-4rem)] overflow-y-auto bg-light_background_default w-full px-6 py-8">
                  <Outlet />
                </div>
              </div>
            </div>
          </Provider>
        </AdminContext.Provider>
      ) : (
        <>
          <Navigate to={"/login"} replace />
        </>
      )}
    </div>
  );
};

export default MainLayout;
